<template>
  <div class="form-resolve">
    <el-dialog v-model="dialog" @close="handleClose" :close-on-click-modal="false">
      <div id="waiting" class="center" v-if="loading"></div>
      <div class="popup-header">
        <p class="title">
          {{ $t('contacts.mail.popup.title') }}
        </p>
      </div>
      <div class="last-message">
        <p class="whitespace-pre-line" >
          {{ $t('contacts.mail.popup.desc') }}
        </p>
      </div>
      <div class="footer">
        <el-button type="primary" @click="redirect" class="btn btn-unresolve">{{ $t('contacts.mail.popup.btn_redirect') }}</el-button>
        <el-button type="primary" @click="back" class="btn btn-back">{{ $t('contacts.mail.popup.btn_back') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      openDialogUnresolveContact: { type: Boolean, required: true, default: false },
      urls: { type: Object, required: true, default: {} },
      lastMessage: { type: String, required: true, default: '' },
    },
    data() {
      return {
        dialog: false,
        loading: false,
      };
    },
    methods: {
      handleClose() {
        window.location.href = '/my-page'
      },
      redirect() {
        window.location.href = '/contacts/mail'
      },

      back() {
        this.handleClose();
      },
    },
    created() {
      this.dialog = this.openDialogUnresolveContact;
    },
  }
</script>

<style lang="scss" scoped>
  .form-resolve {
    text-align: center !important;
    .title {
      font: normal normal normal 17px/37px Kozuka Gothic Pr6N;
      letter-spacing: 1.7px;
      color: #000000;
      font-weight: 700
    }
    .main {
      width: 80%;
      margin: 25px auto;
      background: #F7F3ED 0% 0% no-repeat padding-box;
      letter-spacing: 0.75px;
      color: #000000;
      padding: 25px;
      text-align: left;
      .message {
        border-right: solid 1px #DDD8D1;
      }
    }
    .footer {
      margin-top: 30px;
      .btn {
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #FFFFFF;
        width: 250px;
        height: 50px;
        border-radius: 25px !important;
        margin-left: 25px;
        &:first-child {
          margin-left: 0;
        }
      }
      .btn-unresolve {
        background: #AC3B29 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #AC3B29;
        --el-button-hover-border-color: #AC3B29;
        --el-button-border-color: #AC3B29;
      }
      .btn-back {
        background: #969696 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #969696;
        --el-button-hover-border-color: #969696;
        --el-button-border-color: #969696;
      }
    }
  }
</style>
